import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

function initApp(): void {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

initApp();

if (window.innerWidth > 1200) {
  initApp();
} else {
  location.replace('https://m.diyiedu.com');
}
